export default function employee_id_filter(state = null, action) {
    switch (action.type) {
        case "EMPLOYEE_ID_FILTER_UPDATED":
            return action.id ? parseInt(action.id) : null
        default:
            return state
    }
}
